import { IS_MALE, NEXT_MALE } from "config/tags";

export const commonRouting = ({
  nextUrlPath: nextUrlPathInit,
  question,
  assessment,
  routes,
  profile
}) => {
  let nextUrlPath = nextUrlPathInit;

  // Male / female routing for eligibility.
  if (question.tags.includes(IS_MALE)) {
    if (profile.gender === "M") {
      nextUrlPath = routes.question(
        assessment.questions.find(q => q.tags.includes(NEXT_MALE)).urlPath
      );
    }
  }

  return nextUrlPath;
};
